import assign from 'object-assign';
import RestHelper from '../utils/RestHelper';

function normalizeFormData(data) {
  const normalizedData = {};
  Object.keys(data).forEach((key) => {
    normalizedData[key] = data[key].value;
  });
  return normalizedData;
}

function saveNewsLetterRegistrationFormData(newsletterData, endpoint) {
  const params = {
    params: newsletterData
  };
  return RestHelper
    .post(endpoint, params);
}

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: 'INIT_NEWSLETTER_DATA',
    data: {
      component
    }
  });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: 'SUBMIT_NEWSLETTER_DATA',
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch) => {
  dispatch({
    type: 'SUBMIT_SUCCESSFUL'
  });

  /* dispatch({
    type: 'LOCATION_REDIRECT',
    location: response.headers.location
  }); */
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: 'SUBMIT_ERROR',
    data: {
      error
    }
  });
};

export const submitData = (dispatch, data, endpoint) => {
  const normalizedFormData = normalizeFormData(data);
  dataRequest(dispatch, data, endpoint);
  const resp = saveNewsLetterRegistrationFormData(normalizedFormData, endpoint);
  return resp
    .then((response) => {
      dataRequestSuccess(dispatch, response);
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'INIT_NEWSLETTER_DATA': {
      return assign({}, state, action.data);
    }
    case 'SUBMIT_NEWSLETTER_DATA': {
      return assign({}, state, action.data, { isRequestPending: true });
    }
    case 'SUBMIT_SUCCESSFUL': {
      return assign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case 'SUBMIT_ERROR': {
      return assign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    case 'LOCATION_REDIRECT': {
      window.open(action.location, '_self');
      return state;
    }
    default:
      return state;
  }
}
